import { Auth } from "aws-amplify"

const AWS = require("aws-sdk")

const PutS3Object = {
  putObject: (credentials, bucketName, key, body) => {
    return new Promise((resolve, reject) => {
      const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: 'ap-northeast-1',
        credentials: Auth.essentialCredentials(credentials)
      })
      s3.putObject({
        Body: body,
        Bucket: bucketName, // process.env.S3_BUCKET_NAME,
        Key: key // FILE_NAME
      }, (err, data) => {
        if (err) {
          console.dir(err)
          reject(new Error("S3へファイルをアップロードできません"))
        }
        resolve(data)
      })
    })
  },
  put: (bucketName, key, body) => {
    return Auth.currentCredentials()
      .then(credentials => {
        return PutS3Object.putObject(credentials, bucketName, key, body)
      })
  }
}

export default PutS3Object



// WEBPACK FOOTER //
// ./src/logic/PutS3Object.js